var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _g3, _g4, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4007 29.0994C55.2621 35.323 52.9698 41.306 48.9144 46.0289C44.859 50.7519 39.2914 53.9226 33.1603 55.0007C27.0293 56.0789 20.714 54.9979 15.2906 51.9418C9.86726 48.8857 5.67132 44.0437 3.41775 38.2408C1.16418 32.4378 0.992418 26.033 2.93172 20.1177C4.87103 14.2023 8.80141 9.14235 14.0532 5.79998C19.305 2.45762 25.5532 1.03964 31.7332 1.78765C37.9133 2.53566 43.6428 5.40337 47.9455 9.90218L28.5001 28.5L55.4007 29.0994Z",
    fill: "#EE3145"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4007 29.0994C55.2822 34.4198 53.5886 39.5856 50.5342 43.9436C47.4798 48.3015 43.2016 51.6558 38.2408 53.5824C33.28 55.5089 27.8593 55.9211 22.6642 54.7669C17.4691 53.6127 12.733 50.9438 9.05465 47.0979C5.37634 43.2519 2.92109 38.4016 1.99938 33.1603C1.07767 27.9189 1.7309 22.522 3.87646 17.6519C6.02202 12.7818 9.56354 8.65731 14.0532 5.79998C18.5428 2.94266 23.779 1.48083 29.0994 1.59937L28.5001 28.5L55.4007 29.0994Z",
    fill: "#43D29D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4007 29.0994C55.3022 33.5232 54.1141 37.8545 51.9418 41.7095C49.7695 45.5645 46.68 48.8243 42.947 51.2001C39.2139 53.5759 34.9526 54.9944 30.5404 55.3299C26.1282 55.6654 21.7013 54.9076 17.6519 53.1237C13.6026 51.3397 10.0556 48.5846 7.32538 45.1024C4.59511 41.6202 2.76576 37.5183 1.99938 33.1603C1.233 28.8022 1.55323 24.3224 2.93172 20.1177C4.31021 15.9129 6.7044 12.113 9.90222 9.0546L28.5001 28.5L55.4007 29.0994Z",
    fill: "#EE3145"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4007 29.0994C55.2418 36.2339 52.2552 43.013 47.0979 47.9455C41.9407 52.8779 35.0353 55.5597 27.9008 55.4007C20.7663 55.2417 13.9871 52.2551 9.05465 47.0979C4.12219 41.9406 1.44046 35.0352 1.59941 27.9007L28.5001 28.5L55.4007 29.0994Z",
    fill: "#43D29D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4007 29.0994C55.2822 34.4198 53.5886 39.5856 50.5342 43.9436C47.4798 48.3015 43.2016 51.6558 38.2408 53.5824C33.28 55.5089 27.8593 55.9211 22.6642 54.7669C17.4691 53.6127 12.733 50.9438 9.05465 47.0979L28.5001 28.5L55.4007 29.0994Z",
    fill: "#EE3145"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4007 29.0994C55.322 32.632 54.5483 36.1146 53.1237 39.3482C51.6991 42.5818 49.6515 45.5032 47.0979 47.9455C44.5443 50.3878 41.5347 52.3032 38.2408 53.5824C34.947 54.8615 31.4334 55.4794 27.9008 55.4007L28.5001 28.5L55.4007 29.0994Z",
    fill: "#43D29D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4007 29.0994C55.322 32.632 54.5483 36.1146 53.1237 39.3482C51.6991 42.5818 49.6515 45.5032 47.0979 47.9455L28.5001 28.5L55.4007 29.0994Z",
    fill: "#EE3145"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4007 29.0994C55.4795 25.5667 54.8616 22.0532 53.5824 18.7593C52.3032 15.4654 50.3878 12.4558 47.9455 9.90218L28.5001 28.5L55.4007 29.0994Z",
    fill: "#43D29D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_2089_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4999 46.2689C38.3135 46.2689 46.2689 38.3135 46.2689 28.4999C46.2689 18.6864 38.3135 10.7309 28.4999 10.7309C18.6864 10.7309 10.7309 18.6864 10.7309 28.4999C10.7309 38.3135 18.6864 46.2689 28.4999 46.2689ZM28.4999 51.3458C41.1173 51.3458 51.3458 41.1173 51.3458 28.4999C51.3458 15.8825 41.1173 5.65405 28.4999 5.65405C15.8825 5.65405 5.65405 15.8825 5.65405 28.4999C5.65405 41.1173 15.8825 51.3458 28.4999 51.3458Z",
    fill: "url(#paint0_radial_2089_2)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 50.3304C40.5566 50.3304 50.3305 40.5565 50.3305 28.4999C50.3305 16.4432 40.5566 6.66939 28.5 6.66939C16.4433 6.66939 6.66951 16.4432 6.66951 28.4999C6.66951 40.5565 16.4433 50.3304 28.5 50.3304ZM28.5 55.4072C43.3605 55.4072 55.4073 43.3604 55.4073 28.4999C55.4073 13.6394 43.3605 1.59253 28.5 1.59253C13.6395 1.59253 1.59265 13.6394 1.59265 28.4999C1.59265 43.3604 13.6395 55.4072 28.5 55.4072Z",
    fill: "url(#paint1_radial_2089_2)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2089_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0999 27.9924C35.0999 31.357 32.3723 34.0846 29.0076 34.0846C25.643 34.0846 22.9154 31.357 22.9154 27.9924C22.9154 24.6277 25.643 21.9001 29.0076 21.9001C32.3723 21.9001 35.0999 24.6277 35.0999 27.9924Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2089_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0076 32.5615C31.5311 32.5615 33.5768 30.5159 33.5768 27.9924C33.5768 25.4689 31.5311 23.4232 29.0076 23.4232C26.4841 23.4232 24.4385 25.4689 24.4385 27.9924C24.4385 30.5159 26.4841 32.5615 29.0076 32.5615ZM29.0076 34.0846C32.3723 34.0846 35.0999 31.357 35.0999 27.9924C35.0999 24.6277 32.3723 21.9001 29.0076 21.9001C25.643 21.9001 22.9154 24.6277 22.9154 27.9924C22.9154 31.357 25.643 34.0846 29.0076 34.0846Z",
    fill: "#CCBCE6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2089_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9923 3.62353C27.9923 4.1843 28.4469 4.6389 29.0077 4.6389C29.5685 4.6389 30.0231 4.1843 30.0231 3.62353C30.0231 3.06275 29.5685 2.60815 29.0077 2.60815C28.4469 2.60815 27.9923 3.06275 27.9923 3.62353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9769 53.3767C26.9769 52.8159 27.4315 52.3614 27.9923 52.3614C28.5531 52.3614 29.0077 52.8159 29.0077 53.3767C29.0077 53.9375 28.5531 54.3921 27.9923 54.3921C27.4315 54.3921 26.9769 53.9375 26.9769 53.3767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2844 11.7465C47.2844 12.3073 46.8298 12.7619 46.269 12.7619C45.7082 12.7619 45.2536 12.3073 45.2536 11.7465C45.2536 11.1857 45.7082 10.7311 46.269 10.7311C46.8298 10.7311 47.2844 11.1857 47.2844 11.7465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.269 46.2691C46.269 45.7083 45.8144 45.2537 45.2536 45.2537C44.6929 45.2537 44.2383 45.7083 44.2383 46.2691C44.2383 46.8299 44.6929 47.2845 45.2536 47.2845C45.8144 47.2845 46.269 46.8299 46.269 46.2691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.392 29.0078C54.392 28.447 53.9374 27.9924 53.3766 27.9924C52.8158 27.9924 52.3612 28.447 52.3612 29.0078C52.3612 29.5686 52.8158 30.0232 53.3766 30.0232C53.9374 30.0232 54.392 29.5686 54.392 29.0078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63878 27.9924C4.63878 27.4317 4.18418 26.9771 3.6234 26.9771C3.06263 26.9771 2.60803 27.4317 2.60803 27.9924C2.60803 28.5532 3.06263 29.0078 3.6234 29.0078C4.18418 29.0078 4.63878 28.5532 4.63878 27.9924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71563 10.7311C9.71563 11.2919 10.1702 11.7465 10.731 11.7465C11.2918 11.7465 11.7464 11.2919 11.7464 10.7311C11.7464 10.1704 11.2918 9.71575 10.731 9.71575C10.1702 9.71575 9.71563 10.1704 9.71563 10.7311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71563 45.2537C9.71563 44.693 10.1702 44.2384 10.731 44.2384C11.2918 44.2384 11.7464 44.693 11.7464 45.2537C11.7464 45.8145 11.2918 46.2691 10.731 46.2691C10.1702 46.2691 9.71563 45.8145 9.71563 45.2537Z",
    fill: "white"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9922 5.65405H30.023V7.6848H27.9922V5.65405Z",
    fill: "#D1394A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65702 29.1274L5.64636 27.0967L7.67708 27.0861L7.68773 29.1168L5.65702 29.1274Z",
    fill: "#D1394A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0739 12.6135L13.5177 11.1855L14.9457 12.6294L13.5019 14.0574L12.0739 12.6135Z",
    fill: "#D1394A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 45.009L11.2644 43.5727L12.7007 42.1371L14.1363 43.5735L12.6999 45.009Z",
    fill: "#D1394A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9768 49.315H29.0076V51.3458H26.9768V49.315Z",
    fill: "#D1394A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3227 29.9138L49.312 27.8831L51.3428 27.8724L51.3534 29.9031L49.3227 29.9138Z",
    fill: "#D1394A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0541 44.3704L43.4979 42.9424L44.9259 44.3863L43.4821 45.8143L42.0541 44.3704Z",
    fill: "#D1394A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2991 14.8627L42.8635 13.4263L44.2999 11.9908L45.7354 13.4271L44.2991 14.8627Z",
    fill: "#D1394A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2089_2",
    x: 4.65405,
    y: 4.65405,
    width: 47.6917,
    height: 47.6917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_2089_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2089_2",
    x: 18.9154,
    y: 21.9001,
    width: 20.1844,
    height: 20.1846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2089_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2089_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2089_2",
    x: 18.9154,
    y: 21.9001,
    width: 20.1844,
    height: 20.1846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2089_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2089_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2089_2",
    x: 0.608032,
    y: 0.608154,
    width: 55.7839,
    height: 55.7839,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2089_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2089_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2089_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.37827 34.5347) rotate(38.5169) scale(26.9951)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2089_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.62339 35.6075) rotate(38.5169) scale(31.7943)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56B4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82C9C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinIcon);
export default __webpack_public_path__ + "static/media/spin-icon.fc79ebdf23e5e75884149f61211bfd2e.svg";
export { ForwardRef as ReactComponent };